import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT__VALIDATE_NAME_REGIONAL,
  ENDPOINT_ACTION,
  ENDPOINT_ACTIVE_REGIONAL,
  ENDPOINT_ALL_REGIONALS,
  ENDPOINT_CREATE_REGIONAL,
  ENDPOINT_GET_ALL_REGIONALS,
  ENDPOINT_ORGANIZATIONAL_UNIT,
  ENDPOINT_PROJECT,
  ENDPOINT_REGIONAL,
  ENDPOINT_UPDATE_REGIONAL,
} from './constants';

export function useRegionalService() {
  const { backendGet, backendPost, backendPut, backendPatch } =
    Sebrae.useBackend();

  const {
    fetchData: fetchRegional,
    data,
    loading,
    error,
  } = Sebrae.usePagination(`${ENDPOINT_GET_ALL_REGIONALS}`);

  const returnValidateRegionalName = React.useCallback(
    (idUf, nameRegional) =>
      backendGet(`${ENDPOINT__VALIDATE_NAME_REGIONAL}/${idUf}/${nameRegional}`),
    [backendGet],
  );

  const saveReginal = React.useCallback(
    (data = {}) => {
      return backendPost(`${ENDPOINT_CREATE_REGIONAL}`, data);
    },
    [backendPost],
  );

  const updateReginal = React.useCallback(
    (data = {}, id) => {
      return backendPut(`${ENDPOINT_UPDATE_REGIONAL}/${id}`, data);
    },
    [backendPut],
  );

  const updateClassEditPermission = React.useCallback(
    (id) => {
      return backendPatch(`${ENDPOINT_REGIONAL}/${id}/allows-edit-class`);
    },
    [backendPatch],
  );

  const updatePortalInterviewPermission = React.useCallback(
    (id) => {
      return backendPatch(`${ENDPOINT_REGIONAL}/${id}/allows-portal-interview`);
    },
    [backendPatch],
  );

  const changeStatusRegional = React.useCallback(
    (id, status) =>
      backendPut(`${ENDPOINT_ACTIVE_REGIONAL}/${id}/status/${status}`),
    [backendPut],
  );

  const returnRegionals = React.useCallback(
    (data) => backendGet(`${ENDPOINT_ALL_REGIONALS}`, data),
    [backendGet],
  );

  const returnOrganizationalUnit = React.useCallback(
    (data, sigla) =>
      backendGet(`${ENDPOINT_ORGANIZATIONAL_UNIT}/${sigla}`, data),
    [backendGet],
  );

  const returnProjectByUf = React.useCallback(
    (nameSearch, uf) => backendGet(`${ENDPOINT_PROJECT}/${uf}`, { nameSearch }),
    [backendGet],
  );

  const returnActionByProject = React.useCallback(
    (codigoProjeto, nameSearch) =>
      backendGet(`${ENDPOINT_ACTION}/${codigoProjeto}`, { nameSearch }),
    [backendGet],
  );

  return {
    returnValidateRegionalName,
    changeStatusRegional,
    fetchRegional,
    data,
    loading,
    error,
    saveReginal,
    updateReginal,
    returnRegionals,
    updateClassEditPermission,
    updatePortalInterviewPermission,

    returnOrganizationalUnit,
    returnProjectByUf,
    returnActionByProject,
  };
}
